import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useEffect } from 'react'
import { ToastContainer } from 'react-toastify'

import { theme } from './app/config/theme'
import { AppRouter } from './app/routes'
import { AuthProvider } from './features/auth'
import ErrorBoundary from './shared/components/ErrorBoundary'
import { initializeNumberInputScrollPrevention } from './shared/utils/disableNumberInputScroll'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

function App() {
  // Initialize global handler to prevent scroll-to-change on number inputs
  useEffect(() => {
    const cleanup = initializeNumberInputScrollPrevention()
    return cleanup
  }, [])

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyles styles={{ html: { WebkitFontSmoothing: 'auto' } }} />
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
          <ToastContainer />
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

export default App
